import { htmlSafe, type TrustedHTML } from '@ember/template';

export function isHexColor(value: string) {
  return /^#[0-9A-Fa-f]{6}$/.test(value);
}

export function textColorStyle(colour: string | null): TrustedHTML {
  if (isHexColor(colour || '')) {
    return htmlSafe(`color: ${colour};`);
  }
  return htmlSafe('');
}

export function backgroundColorStyle(colour: string | null): TrustedHTML {
  if (isHexColor(colour || '')) {
    return htmlSafe(`background-color: ${colour};`);
  }
  return htmlSafe('');
}
